import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Home as HomeUa } from './pages/Home-ua';

import './styles/custom.sass';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/ua' element={<HomeUa />} />
        <Route path='/ru' element={<Navigate to='/' replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export { App };
